/* import __COLOCATED_TEMPLATE__ from './mcp-template-list.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type IntlService from 'embercom/services/intl';
import { hasFeature } from 'embercom/helpers/has-feature';
import {
  getAllMcpTemplates,
  type McpTemplateDefinition,
  type McpAuthenticationType,
} from 'embercom/models/workflow-connector/constants/mcp-templates';
import type McpServer from 'embercom/models/workflow-connector/mcp-server';

interface Args {
  mcpServers: McpServer[];
  showMcpServerModal: () => void;
  onTemplateSelect: (template: Template) => void;
}

export interface Template {
  name: string;
  description: string;
  icon: string;
  shouldDisplay: boolean;
  template: boolean;
  authentication?: McpAuthenticationType;
  url?: string;
  id?: string;
}

export default class McpTemplateList extends Component<Args> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  shouldDisplayTemplate(mcpTemplate: McpTemplateDefinition): boolean {
    return mcpTemplate.shouldDisplay !== undefined
      ? mcpTemplate.shouldDisplay
      : !this.args.mcpServers
          .toArray()
          .some((mcpServer: McpServer) => mcpServer.name === mcpTemplate.name);
  }

  get templateList(): Template[] {
    let templates: Template[] = [
      {
        name: this.intl.t('workflow-connector.actions.mcp-actions.template-list.custom-mcp-title'),
        description: this.intl.t(
          'workflow-connector.actions.mcp-actions.template-list.custom-mcp-description',
        ),
        icon: 'mcp/custom-add',
        shouldDisplay: true,
        template: false,
        id: 'custom-mcp-server',
      },
    ];

    let useStreamableHttpTransport = hasFeature(
      'linear-mcp-streamable-http-transport',
      this.appService,
    );
    let mcpTemplates = getAllMcpTemplates();
    for (let mcpTemplate of mcpTemplates) {
      templates.push({
        name: mcpTemplate.name,
        url:
          mcpTemplate.id === 'linear' && useStreamableHttpTransport
            ? 'https://mcp.linear.app/mcp'
            : mcpTemplate.url,
        description: this.intl.t(mcpTemplate.descriptionKey),
        icon: mcpTemplate.icon,
        shouldDisplay: this.shouldDisplayTemplate(mcpTemplate),
        template: true,
        authentication: mcpTemplate.authentication,
        id: mcpTemplate.id,
      });
    }

    return templates;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::McpTemplateList': typeof McpTemplateList;
  }
}
